import React from "react";

const Map = React.memo(() => {
  return (
    <iframe
      src="https://maps.google.com/maps?q=299%20Pine%20Avenue%2C%20Ferndale%2C%20Randburg%2C%202196&output=embed"
      width="100%"  // Set width to 100% for responsiveness
      height="450"  // Set fixed height
      className="mx-auto border border-gray-400 shadow-md mb-8"
      title="Google Maps Location"
      allowFullScreen
      loading="lazy"
      referrerPolicy="no-referrer-when-downgrade"
    />
  );
});

export default Map;
